var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item-content",class:_vm.categoryStyles},[_c('div',{staticClass:"list-item-content-title one-liner"},[_vm._v("\n    "+_vm._s(_vm._f("category")(_vm.category.description))+"\n  ")]),_c('base-btn-group',{attrs:{"state":_vm.state,"button-allow":"","button-warn":"","button-block":""},on:{"click":_vm.changeAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }